import { connect } from 'react-redux'
import relativeDateSelector from './relativeDateSelector'
import RelativeDate from './RelativeDate'

export default connect(
  relativeDateSelector,
  {}
)(RelativeDate)

